import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetPushNotificationById } from "../../services/pushnotification.service";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import moment from 'moment';
import ImagePreview from "../../components/ImagePreview";
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import { constants, customStyles } from "../../utils/constants";
import { FadeLoader } from 'react-spinners';

function NotificationDetails() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [notification, setNotification] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [rows, setRows] = useState([]);

    const fetchNotificationDetails = async () => {
        console.log("Fetching notification details, setting loading to true");
        setLoading(true);
        try {
            const result = await GetPushNotificationById(id); // Fetch notification by ID
            if (result.status && result.data) {
                console.log("Notification data fetched successfully:", result.data);
                setNotification(result.data);
                setRows(result.data.users || []); // Set users data for DataTable
            } else {
                toast.error("Failed to load notification details.");
            }
        } catch (error) {
            console.error("Error fetching notification details:", error);
            if (error.response?.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                toast.error(error.response?.data?.message || "An error occurred.");
            }
        }
        console.log("Finished fetching, setting loading to false");
        setLoading(false);
    };

    useEffect(() => {
        console.log("useEffect triggered with id:", id);
        fetchNotificationDetails();
    }, [id]);

    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const columns = [
        {
            id: 'serialNumber',
            name: 'S.NO',
            maxWidth: '60px',
            center: true,
            selector: (row, index) => index + 1,
        },
        {
            id: 'fullName',
            name: 'Name',
            maxWidth: '160px',
            selector: row => row.fullName || 'N/A',
        },
        {
            id: 'email',
            name: 'Email',
            minWidth: '180px',
            selector: row => row.email || 'N/A',
        },
    ];

    if (loading) {
        return (
            <div className='spin-loader d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                <FadeLoader color={'#41D2D2'} height={10} />
            </div>
        );
    }

    return (
        <div>
            <h3 className='page-heading'>Notification Details</h3>
            <hr />
            <>
                <p><b>Title:</b> {notification?.title || 'Untitled'}</p>
                <p><b>Message:</b> {notification?.message}</p>
                <p><b>Created At:</b> {moment(notification?.createdAt).format('YYYY-MM-DD HH:mm')}</p>
                <hr />
                <h5 className='page-heading'>Users</h5>
                <div className="theme-dataGrid products-dataGrid m-3">
                    <DataTable
                        columns={columns}
                        data={rows}
                        progressPending={loading}
                        customStyles={customStyles}
                        striped
                        highlightOnHover
                        progressComponent={<BarLoader color={'#41D2D2'} loading={loading} height={4} width="100%" />}
                    />
                </div>
                <ImagePreview
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    size="lg"
                    content={selectedImage}
                />
            </>
        </div>
    );
}

export default NotificationDetails;
